// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__DkQW+"};